import { type ButtonHTMLAttributes, type FC } from "react";
import { cn } from "@/lib/utils";

const SweepstakesButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  className,
  children,
  ...props
}) => (
  <button
    type="button"
    className={cn(
      "inline-flex items-center justify-center rounded-[100px] bg-[#1f2022] px-8 py-[15px] font-ppMori text-[14px] leading-[20px] text-white transition-opacity hover:opacity-90 md:text-[16px] md:leading-[22px] 2xl:text-[18px] 2xl:leading-[26px]",
      className,
    )}
    {...props}
  >
    {children}
  </button>
);

export default SweepstakesButton;
